<template>
    <div class="business">
        <home-head
      :data="{
        Ename: 'USINESS PROFILE',
        Cname: '业务概况',
        Fname: 'B',
        url: '/business',
      }"
    ></home-head>
        <div class="list">
           <ul>
               <li v-for="(item,index) of Data" :key="index">
                   <router-link to="">
                   <div class="brand">
                       <div class="item-img"><img :src="item.img"/></div>
                       <div class="item-name">{{item.name}}</div>
                   </div>
                   <div class="content">
                       <div class="item-name">{{item.name}}</div>
                       <div class="detail">{{item.content}}</div>
                   </div>
                   </router-link>
               </li>
           </ul>
        </div>
    </div>
</template>
<script>
import { getHomeBusiness } from '@/api'
import HomeHead from "@/components/HomeHead";
export default {
    components: {
    ["home-head"]: HomeHead,
  },
    data(){
        return{
            Data: []
        }
    },
    methods:{
        async getHomeBusiness(){
            const result =  await getHomeBusiness()
            this.Data = result.data.data
        }
    },
    created(){
        this.getHomeBusiness()
    }
}
</script>
<style lang="scss" scoped>
    .business{
        
    }
    .list{
        font-size: 0.12rem;
        margin: 30px 0;
        ul{
            li{
                width: 171px;
                // height: 220px;
                display: inline-block;
               
                // border: 1px solid black;
                // padding: 15px;
                margin: 13px;
                text-align: center;
                position: relative;
                .brand{
                    position: relative;
                   
                    .item-img{
                        width: 160px;
                        height: 160px;
                        border-radius: 50%;
                        background: #F0F5FA;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: auto;
                        
                         img{
                            width: 80px;
                            height: 86px;
                        }
                      
                    }
                }
                 .item-name{
                            margin:15px 25px;
                            font-size: 18px;
                        }
                .content{
                    padding:0 15px;
                    opacity: 0;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 141px;
                    height: 100%;
                    margin: 0 auto;
                    color: #fff;
                    transform:rotateY(180deg);
                    .detail{
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 9;
                        overflow: hidden;
                    }
                    
                  
                }
                &:hover{
                    // transition:all 1.2s ease ;
                   
                    .brand{
                        transition:all 1.2s  ease-out;
                        transform:rotateY(180deg);
                        opacity: 0;
                    }
                     .content{
                        background: #606060;
                        transition:all 1.2s ease;
                        transform:rotateY(360deg);
                      
                        opacity: 1;
                        // z-index: 1;
                        
                    }
                }
            }
        }
    }
</style>